import { atom } from 'jotai'

export const userDataAtom = atom({})

export const userMenuAtom = atom(false)
